"use strict";

exports.__esModule = true;
exports.ElementColorSourceControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _DeviceColorSources = require("../../../Device/DeviceColorSources");
var _LayoutSettingsContext = require("../../LayoutSettingsContext");
var _dec, _class, _ElementColorSourceControlGroup;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Controls for changing colorSource and backgroundColorSource properties of an element.
 */
var ElementColorSourceControlGroup = exports.ElementColorSourceControlGroup = (_dec = _LayoutSettingsContext.LayoutSettingsContext.withContext, _dec(_class = (_ElementColorSourceControlGroup = /*#__PURE__*/function (_Component) {
  function ElementColorSourceControlGroup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementColorSourceControlGroup, _Component);
  var _proto = ElementColorSourceControlGroup.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      elementEditor = _this$props.elementEditor,
      controlPaths = _this$props.controlPaths,
      layoutSettings = _this$props.layoutSettings,
      width = _this$props.width;
    var colorSource = controlPaths.colorSource,
      backgroundColorSource = controlPaths.backgroundColorSource;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, colorSource && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      key: "colorSource",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementColorSourceControlGroup.colorSource.label",
        defaultMessage: "Color Source"
      })
    }, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      vertical: true,
      style: {
        width: width
      }
    }, /*#__PURE__*/_react["default"].createElement(_DeviceColorSources.DeviceColorSourcePicker, {
      width: width,
      height: "2rem",
      allowCurrentCycle: layoutSettings.colorSource.allowCurrentCycle,
      value: elementEditor.getProp(colorSource, "colorSource", ""),
      onChange: function onChange(value) {
        return colorSource !== undefined && elementEditor.setProp(colorSource, "colorSource", value);
      }
    }))), backgroundColorSource && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      key: "backgroundColorSource",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementColorSourceControlGroup.backgroundColorSource.label",
        defaultMessage: "Background Color Source"
      })
    }, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      vertical: true,
      style: {
        width: width
      }
    }, /*#__PURE__*/_react["default"].createElement(_DeviceColorSources.DeviceColorSourcePicker, {
      width: width,
      height: "2rem",
      allowCurrentCycle: layoutSettings.backgroundColorSource.allowCurrentCycle,
      value: elementEditor.getProp(backgroundColorSource, "backgroundColorSource", ""),
      onChange: function onChange(value) {
        return backgroundColorSource !== undefined && elementEditor.setProp(backgroundColorSource, "backgroundColorSource", value);
      }
    }))));
  };
  return ElementColorSourceControlGroup;
}(_react.Component), _ElementColorSourceControlGroup.defaultProps = {
  layoutSettings: undefined,
  width: "100%"
}, _ElementColorSourceControlGroup)) || _class);